import { render, staticRenderFns } from "./GetClassesRecordAxiosBySchool.vue?vue&type=template&id=e479e7f8&"
import script from "./GetClassesRecordAxiosBySchool.vue?vue&type=script&lang=js&"
export * from "./GetClassesRecordAxiosBySchool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports